import { EMPTY_STRING } from '../../../constants/common'
import {
  EMAIL_FOLDER_DEFAULT_VALUE,
  LIST_ROUTE_NAMES,
} from '../../../constants/route'
import { useLinkLikeClick } from '../../../hooks'

function EmailAccountWidgetItemContent({
  ContentContainer,
  profileLinkParams = EMPTY_STRING,
  value,
  ...restProps
}) {
  const { handleClick } = useLinkLikeClick()

  function handleClickTitle() {
    handleClick({
      link: LIST_ROUTE_NAMES.emails({
        additionalParams: `?sub=${EMAIL_FOLDER_DEFAULT_VALUE}&account=${value}${profileLinkParams}`,
      }),
      outsideLink: true,
    })
  }

  return <ContentContainer {...restProps} onClickTitle={handleClickTitle} />
}

export default EmailAccountWidgetItemContent
